import { limit, orderBy, query, where } from 'firebase/firestore'
import type {
  PlanningAdjustmentFilter,
  PlanningAdjustmentSort,
} from '~/features/PlanningAdjustments/planningAdjustmentsModel'
import type { PlanningAdjustment, PlanningAdjustmentStatus } from '~/models'
import { PaginatedArrayService } from './serviceLivePaginatedArray'

const ALL_TYPES = ['customerUnavailable', 'onDemand', 'forcedDeliveryDate']

export class PlanningAdjustmentService extends PaginatedArrayService<PlanningAdjustment> {
  constructor() {
    super('PlanningAdjustments')
  }

  public listenForStatusAndType(
    status: PlanningAdjustmentStatus,
    type: PlanningAdjustmentFilter,
    sort: PlanningAdjustmentSort,
    userId?: string,
  ): void {
    const typeFilter = type === 'all' ? ALL_TYPES : [type]

    let listenQuery = query(
      this.collection,
      where('Status', '==', status),
      where('Type', 'in', typeFilter),
      orderBy(sort.fieldName, sort.direction),
      limit(this.FETCH_LIMIT),
    )

    if (userId) {
      listenQuery = query(listenQuery, where('UserId', '==', userId))
    }

    this.listen(listenQuery)
  }
}
